/** @format */

import {format} from 'date-fns';

import {DTO_DATE_FORMAT} from '../../constants/common';
import {LogRecordFromQuery} from '../../types';
import {LogsGroupedCollection} from '../../models/scatters';
import {getYandexChangeGroup} from './getYandexChangeGroup';

const getLogsCollection = (data: ReadonlyArray<LogRecordFromQuery>): LogsGroupedCollection => {
  return data.reduce<LogsGroupedCollection>((acc, log) => {
    if (log?.time) {
      const parsedDate = format(log.time, DTO_DATE_FORMAT);
      const group = getYandexChangeGroup(log.group);

      const bucket = acc[parsedDate] ?? {total: 0, byGroup: {}};
      bucket.total += 1;
      bucket.byGroup[group] = (bucket.byGroup[group] ?? 0) + 1;
      acc[parsedDate] = bucket;
    }

    return acc;
  }, {});
};

export {getLogsCollection};
